import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";

const BottomNavigation = () => {
  const [activeTab, setActiveTab] = useState("home");
  const [isMobile, setIsMobile] = useState(true); // assume mobile initially
  const navigate = useNavigate();
  const location = useLocation();
  const getRoleType = sessionStorage.getItem("info") ? JSON.parse(sessionStorage.getItem("info"))?.type : null;

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // ✅ Conditional rendering AFTER hooks
  if (location.pathname === "/login" || !isMobile) return null;

  const tabs = [
    { key: "home", icon: "fas fa-home", label: "Home", url: `${getRoleType === "financer" ? "/employee-dashboard" : "/index"}` },
    {
      key: "support",
      icon: "fas fa-headset",
      label: "Support",
      url: "/support",
    },
    {
      key: "profile",
      icon: "fas fa-user",
      label: "Settings",
      url: "/settings",
    },
  ];

  return (
    <div
      style={{
        position: "fixed",
        bottom: "6%",
        left: "50%",
        transform: "translateX(-50%)",
        background: "#ffffff",
        borderRadius: "30px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        padding: "12px 40px",
        display: "flex",
        gap: "50px",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      {tabs.map((tab) => (
        <div
          key={tab.key}
          onClick={() => {
            setActiveTab(tab.key);
            navigate(tab.url);
          }}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            color: activeTab === tab.key ? "rgb(58, 181, 75)" : "#555",
            cursor: "pointer",
          }}
        >
          <i className={tab.icon} style={{ fontSize: 20 }}></i>
          <span style={{ fontSize: 12, marginTop: 4 }}>{tab.label}</span>
        </div>
      ))}
    </div>
  );
};

export default BottomNavigation;
